import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowRight, faEllipsis } from '@fortawesome/free-solid-svg-icons';
import { useNavigate } from 'react-router-dom';
import { GlobeIcon } from '../lib/utils.tsx';
import projects from '../lib/project.ts';

const FEATURED_COUNT = 2;

const Projects = () => {

  const navigate = useNavigate();
  const featuredProjects = projects.slice(0, FEATURED_COUNT);
  const remainingCount = projects.length - FEATURED_COUNT;

  return (
    <div>
      <div className="mb-10 mt-8 md:mt-0 flex flex-col lg:flex-row lg:items-end lg:justify-between gap-3 text-center lg:text-left">
        <div>
          <h3 className="text-3xl md:text-4xl font-bold">Projects</h3>
          <div className="mt-2 h-1 w-16 mx-auto lg:mx-0 rounded-full bg-gradient-to-r from-orange-400 to-orange-600" />
        </div>
        {/* <button
          onClick={() => navigate("/projects")}
          className="group self-center lg:self-auto inline-flex items-center gap-2 text-sm font-semibold text-orange-400
            border border-orange-400/40 rounded-full px-5 py-2
            hover:text-orange-300 hover:border-orange-400 hover:bg-orange-400/10 transition-colors"
        >
          View All Projects
          <FontAwesomeIcon icon={faArrowRight} size="sm" className="transition-transform duration-300 group-hover:translate-x-1" />
        </button> */}
      </div>

      <div className="relative">
        <div className="absolute left-4 md:left-6 top-2 bottom-2 w-px bg-gradient-to-b from-orange-400 via-orange-400/40 to-transparent" />

        <div className="space-y-5">
          {featuredProjects.map((project, index) => (
            <div key={index} className="relative pl-12 md:pl-16">
              <div className="absolute left-0 top-0 w-8 h-8 md:w-12 md:h-12 rounded-full bg-gray-900 border-2 border-orange-400 flex items-center justify-center text-orange-400 font-bold text-xs md:text-sm shadow-[0_0_12px_rgba(251,146,60,0.35)]">
                {String(index + 1).padStart(2, '0')}
              </div>

              <div
                onClick={() => navigate("/projects")}
                className="group relative rounded-2xl p-[1px] overflow-hidden cursor-pointer
                  bg-gradient-to-br from-gray-700/80 to-gray-800/40
                  hover:from-orange-400/70 hover:to-orange-600/30
                  transition-all duration-300 hover:-translate-y-1"
              >
                {/* soft corner glow on hover */}
                <div className="pointer-events-none absolute -top-16 -right-16 w-40 h-40 rounded-full bg-orange-500/0 blur-3xl transition-all duration-500 group-hover:bg-orange-500/20" />

                <div className="relative h-full rounded-2xl bg-gray-900/90 backdrop-blur-sm p-6 flex flex-col sm:flex-row sm:items-center gap-6">
                  <div className="flex h-16 w-16 shrink-0 items-center justify-center rounded-xl bg-white/95 p-2 shadow-md ring-1 ring-black/5 mx-auto sm:mx-0">
                    <img
                      src={project.imageUrl}
                      alt={`${project.name} Logo`}
                      className="max-h-full max-w-full object-contain transition-transform duration-300 group-hover:scale-110"
                    />
                  </div>

                  <div className="flex-1 min-w-0">
                    <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-2 mb-3 text-center sm:text-left">
                      <h3 className="text-xl font-bold text-white transition-colors group-hover:text-orange-300">
                        {project.name}
                      </h3>
                      {project.info && project.info[0] && (
                        <span className="inline-flex w-fit mx-auto sm:mx-0 items-center gap-1 rounded-full bg-gray-800 border border-gray-700 px-3 py-1 text-xs text-gray-300">
                          <GlobeIcon className="h-3.5 w-3.5" />
                          {project.info[0]}
                        </span>
                      )}
                    </div>

                    <div className="flex flex-row flex-wrap justify-center sm:justify-start items-start gap-1.5">
                      {project.tech &&
                        project.tech.map((tech, idx) => (
                          <span
                            key={idx}
                            className="inline-flex items-center rounded-md px-2.5 py-1 text-xs
                              bg-gray-800 text-gray-300 border border-gray-700
                              transition-colors group-hover:border-orange-400/30"
                          >
                            {tech}
                          </span>
                        ))}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}

          {remainingCount > 0 && (
            <div className="relative pl-12 md:pl-16">
              <div className="absolute left-0 top-0 w-8 h-8 md:w-12 md:h-12 rounded-full bg-gray-900 border-2 border-dashed border-gray-600 flex items-center justify-center text-gray-400">
                <FontAwesomeIcon icon={faEllipsis} className="text-xs md:text-sm" />
              </div>

              <div
                onClick={() => navigate("/projects")}
                className="group flex items-center justify-center gap-3 h-16 md:h-[calc(3rem)] rounded-2xl border border-dashed border-gray-700
                  cursor-pointer text-gray-400
                  hover:border-orange-400/60 hover:text-orange-300 hover:bg-orange-400/5 transition-all duration-300"
              >
                <span className="text-sm font-semibold">. . . more project{remainingCount > 1 ? 's' : ''}</span>
                <FontAwesomeIcon icon={faArrowRight} size="sm" className="transition-transform duration-300 group-hover:translate-x-1" />
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default Projects;
